module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_02.9cf83aa1.png";